import { ContentList } from './ContentList';

export type {
  TypeContentListProps,
  TypeContentListItem,
  TypeContentListTipo,
} from './types';
export default ContentList;
